import { DataOpsState } from '../types';

export const dataOpsInitialState: DataOpsState = {
  pendingMessages: {},
  patches: {},
  entityIdToProductKeyId: {},
  productKeyIdToEntityId: {},
  amendingStatus: {},
};
